<div class="modal-header">
  <h4 class="modal-title">Document Viewer</h4>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body embed-responsive embed-responsive-4by3">
  
  <iframe *ngIf="jotUrl" class="embed-responsive-item" id="JotFormIFrame" title="Embedded Form" allow="geolocation; microphone; camera" [src]="jotUrl"></iframe>
  <p>
    Having trouble viewing this document?
    <a [routerLink]="" (click)="viewDocument()" class="text-nowrap">
      View Document.
    </a>
  </p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="close()">Close</button>
</div>
